import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import * as fromStore from '@usimweb/state/store';

import { Store } from '@ngrx/store';
import { take, switchMap, catchError, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable()
export class VersionsGuard {
  constructor(private store: Store<fromStore.DashboardState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.checkStore(route).pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.store.select(fromStore.getProjectsLoaded).pipe(
      tap((loaded) => {
        const id = route.params['id'];
        this.store.dispatch(new fromStore.ClearVersions());
        this.store.dispatch(new fromStore.PollVersions(id));
      }),
      // unsubscribe the observable if loaded true
      // filter((loaded) => loaded === true),
      take(1)
    );
  }

  // checkStore(route: ActivatedRouteSnapshot): Observable<boolean> {
  //   return this.store.select(fromStore.getSelectedProject).pipe(
  //     map((versions: Versions[]) => {
  //       const isVersions = !!(versions.length > 0);
  //       if (!isVersions) {
  //         const id = route.params['id'];
  //         this.store.dispatch(new fromStore.LoadVersions(id));
  //         return true;
  //       }
  //       if (isVersions) {
  //         this.store.dispatch(new fromStore.GetVersions(versions));
  //         return true;
  //       }
  //       return false;
  //     }),
  //     take(1)
  //   );
  // }
}
